import React, { useEffect, useRef, useState } from "react";
import { getCourses } from "../../../helper/apicalls/course";
import { getCoins } from "../../../helper/apicalls/gamification";
import Cookies from "js-cookie";
import GlobalLoader from "../../common/GlobalLoader";
import "../../../styles/admin/coinsAllocation.scss";

const getInitialSettings = (type) => [
  {
    key: "login",
    label: "Login",
    enabled: false,
    [type === "experience" ? "xp" : "coins"]: "",
  },
  {
    key: "streak",
    label: "Streak",
    enabled: false,
    [type === "experience" ? "xp" : "coins"]: "",
  },
  {
    key: "page_completion",
    label: "Page Completion",
    enabled: false,
    [type === "experience" ? "xp" : "coins"]: "",
  },
  {
    key: "quiz_completion",
    label: "Quiz",
    enabled: false,
    [type === "experience" ? "xp" : "coins"]: "",
  },
  {
    key: "test_completion",
    label: "Test",
    enabled: false,
    [type === "experience" ? "xp" : "coins"]: "",
  },
];

const CoinsAllocation = ({ type, state, setState }) => {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [settings, setSettings] = useState([]);
  const [loader, setLoader] = useState(false);

  const hydratedRef = useRef({});

  useEffect(() => {
    const loadCourses = async () => {
      setLoader(true);
      try {
        const res = await getCourses();
        setCourses(res);
        if (res?.length) setSelectedCourse(res[0]);
      } finally {
        setLoader(false);
      }
    };
    loadCourses();
  }, []);

  /* ---------- LOAD COINS (COURSE-SPECIFIC) ---------- */
  useEffect(() => {
    if (!selectedCourse) return;

    if (hydratedRef.current[`${selectedCourse.id}_${type}`]) {
      setSettings(state[selectedCourse.id] || getInitialSettings(type));
      return;
    }

    const fetchCoinsData = async () => {
      setLoader(true);
      try {
        const token = Cookies.get("admin_token");
        const data = await getCoins(token, selectedCourse.id, type);

        const courseData = Array.isArray(data) ? data[0] : data;

        const initial = getInitialSettings(type);
        const fieldName = type === "experience" ? "xp" : "coins";

        const mapped = courseData
          ? initial.map((s) => ({
              ...s,
              enabled: courseData[`${s.key}_${fieldName}`] > 0,
              [fieldName]: courseData[`${s.key}_${fieldName}`] || "",
            }))
          : initial;
        hydratedRef.current[`${selectedCourse.id}_${type}`] = true;

        setSettings(mapped);
        setState((prev) => ({ ...prev, [selectedCourse.id]: mapped }));
      } catch (e) {
        console.error(e);
      } finally {
        setLoader(false);
      }
    };

    fetchCoinsData();
  }, [selectedCourse, type]);

  /* ---------- EDIT HANDLERS ---------- */
  const toggleSetting = (key) => {
    setSettings((prev) => {
      const updated = prev.map((i) =>
        i.key === key ? { ...i, enabled: !i.enabled } : i
      );
      setState((s) => ({ ...s, [selectedCourse.id]: updated }));
      return updated;
    });
  };

  const updateCoinsValue = (key, value) => {
    setSettings((prev) => {
      const updated = prev.map((i) => {
        const fieldName = type === "experience" ? "xp" : "coins";
        return i.key === key ? { ...i, [fieldName]: value } : i;
      });
      setState((s) => ({ ...s, [selectedCourse.id]: updated }));
      return updated;
    });
  };

  return (
    <>
      {loader && <GlobalLoader visible text="Loading..." />}

      <div className="coins-body">
        <aside className="courses-panel">
          {courses.map((c) => (
            <div
              key={c.id}
              className={`course-item ${
                selectedCourse?.id === c.id ? "active" : ""
              }`}
              onClick={() => setSelectedCourse(c)}
            >
              {c.name}
            </div>
          ))}
        </aside>

        <section className="allocation-panel">
          {settings.map((item) => {
            const fieldName = type === "experience" ? "xp" : "coins";
            return (
              <div className="allocation-card" key={item.key}>
                <div className="left">
                  <span className="label">Action</span>
                  <strong>{item.label}</strong>
                </div>

                <div className="right">
                  <input
                    type="number"
                    value={item[fieldName]}
                    disabled={!item.enabled}
                    onChange={(e) => updateCoinsValue(item.key, e.target.value)}
                  />

                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={item.enabled}
                      onChange={() => toggleSetting(item.key)}
                    />
                    <span className="slider" />
                  </label>
                </div>
              </div>
            );
          })}
        </section>
      </div>
    </>
  );
};

export default CoinsAllocation;
